export enum forgotEmailStep {
    initial,
    verificationCode,
    emailNotVerified,
    success,
}

export interface IRecoverEmailApi {
    email: string;
    isVerified: boolean;
}
